import React from 'react';

import PropTypes from 'prop-types';

export const Agents = ({ agents }) => {
    if (!agents || agents.length === 0) {
        return 'No Sales Channel Selected';
    }

    return (
        <span>
            Agents: { agents.map((agent) => agent.name).join(', ') }
        </span>
    );
};

Agents.propTypes = {
    agents: PropTypes.arrayOf({
        name: PropTypes.string.isRequired,
    }).isRequired,
};

export default Agents;
